export default [
  {
    path: '/master-jenis-ruangan',
    redirect: '/master-jenis-ruangan',
    name: 'masterJenisRuangan',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'masterJenisRuanganIndex',
        component: () => import('@/views/master/jenisRuangan/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'master-jenis-ruangan',
          pageTitle: 'Master Jenis Ruangan',
          breadcrumb: [
            {
              text: 'Master Jenis Ruangan',
              active: true,
            },
          ],
        },
      },
      {
        path: '/master-jenis-ruangan/input',
        name: 'masterJenisRuanganInput',
        component: () => import('@/views/master/jenisRuangan/Tambah.vue'),
        meta: {
          action: 'Buat',
          resource: 'master-jenis-ruangan',
          pageTitle: 'Input Jenis Ruangan',
          breadcrumb: [
            {
              text: 'Master Jenis Ruangan',
            },
            {
              text: 'Input',
              active: true,
            },
          ],
        },
      },
      {
        path: '/master-jenis-ruangan/ubah/:id',
        name: 'masterJenisRuanganUbah',
        component: () => import('@/views/master/jenisRuangan/Ubah.vue'),
        meta: {
          action: 'Ubah',
          resource: 'master-jenis-ruangan',
          pageTitle: 'Ubah Jenis Ruangan',
          breadcrumb: [
            {
              text: 'Master Jenis Ruangan',
            },
            {
              text: 'Ubah',
              active: true,
            },
          ],
        },
      },
    ],
  },
]
